'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const CorridorChartInner = dynamic(() => import('./CorridorChartInner'), { ssr: false });

export default function CorridorActivityChart() {
  return (
    <div
      className="rounded-2xl p-6 shadow-card"
      style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
    >
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base font-semibold">Market Corridor Activity</h3>
          <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
            Trade enquiries by corridor — Jan to Jul 2026
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {[
            { label: 'MY→CN', color: 'var(--emerald-bright)' },
            { label: 'MY→US', color: 'var(--gold)' },
            { label: 'MY→GCC', color: 'var(--info)' },
            { label: 'MY→OIC', color: '#A855F7' },
          ]?.map((leg) => (
            <div key={`leg-${leg?.label}`} className="flex items-center gap-1.5 text-xs" style={{ color: 'var(--muted-foreground)' }}>
              <span className="w-2.5 h-2.5 rounded-sm" style={{ background: leg?.color }} />
              {leg?.label}
            </div>
          ))}
        </div>
      </div>
      <CorridorChartInner />
    </div>
  );
}